__turbopack_context__.v({
  "activitiesLoading": "ActivitiesLoading-module__nAEkmq__activitiesLoading",
  "activitiesLoading__Icon": "ActivitiesLoading-module__nAEkmq__activitiesLoading__Icon",
});
